import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

/**
 * This component is used to define a template with a name property that can be used in other components as inner items.
 *
 * @example
 * <parent>
 *    <cw-named-template name="first">FIRST</cw-named-template>
 *    <cw-named-template name="second">SECOND</cw-named-template>
 *    <cw-named-template name="third">THIRD</cw-named-template>
 * </parent>
 */
@Component({
    selector: 'cw-named-template',
    templateUrl: './named-template.component.html',
    standalone: false,
})
export class NamedTemplateComponent {
    /**
     * The name of the template.
     * This property is used to identify the template in other components by name.
     */
    @Input() name!: string;

    /**
     * The template insinde this component. To be used in other components with ngTemplateOutlet.
     */
    @ViewChild(TemplateRef, { static: true }) template!: TemplateRef<any>;
}
